import { createSlice } from '@reduxjs/toolkit'
import helper from '../../Helper';
import API from "../../APIS/index";

let frontUrl = helper.FrontBackendURL();

const initialState = {
    loading: false,
    updateProfileRes: [],
    addCPFRes: [],
    error: "",
}

const profileSlice = createSlice({
    name: 'profile',
    initialState,
    reducers: {
        update: (state, action) => {
            state.updateProfileRes = action.payload
        },
        addcpf: (state, action) => {
            state.addCPFRes = action.payload
        },
    }
})

export const { update, addcpf } = profileSlice.actions;
export default profileSlice.reducer;

export const updateProfile = (data, type, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API?.saveuserprofile}`, data, type);
            callback(response)
            dispatch(update(response.data))
            return response.data
        } catch (e) {
            return console.error(e.message)
        }
    };


export const addCpfUserProfile = (data, type, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API?.ADD_CPF}`, data);
            callback(response)
            dispatch(addcpf(response.data))
            return response.data
        } catch (e) {
            return console.error(e.message)
        }
    };

